import { FeatureFlagName } from '@repo/shared/dtos/feature-flag'
import { DataStatus } from '@repo/ui/utils'

import { FeatureFlagForOrganization } from '@/store/feature-flags/types'
import { getCurrentOrganization } from '@/store/helpers'
import { useStoreState } from '@/store/hooks'

export function hasFeature(
  flags: FeatureFlagForOrganization[],
  flagName: FeatureFlagName,
): boolean {
  return flags.some((flag) => flag === flagName)
}

export function useFeatureFlags() {
  const org = useStoreState(getCurrentOrganization)
  const hasFeature = (flagName: FeatureFlagName): boolean => {
    if (DataStatus.isFulfilled(org)) {
      return org.featureFlags.some((flag) => flag === flagName)
    }
    return false
  }
  return { hasFeature }
}
